import $ from 'jquery';

export default {
    name: 'examen-cliniques',
    components: {},
    props: [
        "consultation_id", "appareil_examines", "hn", 
        "etat_traitement", "active_role", "jn", "can_show_empty"
    ],
    data() {
        return {
            is_loading: true,
            is_empty: false,

            appareil_a_examiner: {},
            to_be_deleted: {},

            save_loading: false,
            observation: '',
            del_loading: false,
            is_confirm: false,
        }
    },

    watch: {
        appareil_examines() {
            this.getAppareilsExamines()
        }
    },

    computed: {

    },

    mounted() {

        this.getAppareilsExamines()
    },

    methods: {
        getAppareilsExamines() {
            this.is_loading = true
            if (this.appareil_examines.length > 0) {
                this.is_empty = false
            } else {
                this.is_empty = true
            }
            setTimeout(() => {
               this.is_loading = false 
            }, 500);
        },

        setAppareilToExamine(v) {
            this.appareil_a_examiner = {
                consultation_appareil_id: v.consultation_appareil_id,
                appareil: v.consultation_appareil
            }
        },

        setToDeleteObservation(obs) {
            this.to_be_deleted = {
                id: obs.id,
                libelle: obs.observation
            }
        },

        async saveExamination() {
            const isValid = await this.$refs.observation_form.validate();

            if (!isValid) {
                return;
            }
            this.save_loading = true

            let data = {
                observation: this.observation,
                consultation_appareil_id: parseInt(this.appareil_a_examiner.consultation_appareil_id)
            }
            this.$store.dispatch('saveObservationAppareil', data).then((response) => {
                if (response > 0) {
                    this.successToast("Observation ajoutée avec succès")

                    this.observation = ''
                    this.$refs.modal_observation.click();
                    this.$refs.observation_form.reset();

                    this.$emit('emitProtocole', this.jn)
                }

                this.save_loading = false
            })

        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }
            let data = {
                id: this.to_be_deleted.id
            }

            console.log(data)
            this.$store.dispatch('deleteAppareilObservation', data).then((response) => {
                if (response > 0) {
                    this.successToast("Observation supprimée avec succès")
                    this.$emit('emitProtocole', this.jn)

                    this.is_confirm = false
                    this.$refs.del_obs.click();
                }
                this.del_loading = false
            }).catch((err) => {
                console.log("ERROR CATCH: ", err)
                this.del_loading = false
            })
        },
    }
}


